import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { PromptApi } from './API';
import env from '../misc/env';
import { retryOnNetworkFailure, extractMessageFromError } from '../utils/errorUtil';
import InfiniteScrollProvider from '../data/InfiniteScrollProvider';
import { InternalOpsAPI } from '../iam/API';
import Prompt, { PromptType, PromptDesigneeType } from './Prompt';
import { makeMomentSorter } from '../utils/arrayUtil';
import { concatMap } from 'rxjs/operators';
import { filterNonNil } from '../utils/rxUtil';
import { match } from '../utils/patternMatchUtil';
import { RealtimeEvent } from '@taxfyle/api-internal/internal/realtime_pb';
import { CreatePromptRequest, PromptDesignee as DesigneeProto, PromptQuestionInput } from '@taxfyle/api-internal/internal/prompt_pb';
var TypeCase = RealtimeEvent.TypeCase;

/**
 * Prompt store.
 */
var PromptStore = /*#__PURE__*/function (_Store) {
  function PromptStore() {
    var _this;
    _classCallCheck(this, PromptStore);
    _this = _callSuper(this, PromptStore, arguments);
    _this.prompts = _this.collection({
      model: Prompt
    });
    _this.api = new PromptApi({
      baseURL: env.WORK_DOTNET_API,
      token$: _this.rootStore.authStore.token$
    }, _this.rootStore.workRealtime$);
    _this.internalOpsAPI = new InternalOpsAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    /**
     * Prompt events from the realtime channel.
     */
    _this.events$ = _this.api.events$.pipe(concatMap(function (e) {
      return _this.mapPromptRealtimeEvent(e);
    }), filterNonNil());
    /**
     * Primes a prompt in the local collection.
     *
     * @param id
     * @returns {Prompt}
     */
    _this.primePrompt = function (_ref) {
      var id = _ref.id;
      var existing = _this.prompts.get(id);
      if (existing) {
        return existing;
      }
      return _this.prompts.set({
        id: id
      });
    };
    _this.scrollProviders = new Map();
    _this.events$.subscribe();
    return _this;
  }
  _inherits(PromptStore, _Store);
  return _createClass(PromptStore, [{
    key: "forJob",
    value:
    /**
     * Returns prompts for the specified job.
     *
     * @param jobId The job ID to look up prompts for.
     * @param includeAll When `false` (default) filters out deleted prompts
     * @returns {Prompt[]}
     */
    function forJob(jobId) {
      var includeAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.prompts.filter(function (p) {
        if (p.jobId !== jobId) {
          return false;
        }
        if (includeAll) {
          return true;
        } else {
          return !p.deleted;
        }
      }).sort(makeMomentSorter('desc', function (v) {
        return v.dateCreated;
      }));
    }

    /**
     * Creates a new prompt
     */
  }, {
    key: "createPrompt",
    value: (function () {
      var _createPrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(promptPayload) {
        var result, prompt;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.api.createPrompt(new CreatePromptRequest().setJobId(promptPayload.jobId).setTitle(promptPayload.title).setDescription(promptPayload.description).setQuestion(mapPromptInput(promptPayload.promptInput)).setDesignee(match(promptPayload.designee, _defineProperty(_defineProperty(_defineProperty({}, PromptDesigneeType.CLIENT, function () {
                return DesigneeProto.CLIENT;
              }), PromptDesigneeType.PROVIDER, function () {
                return DesigneeProto.PROVIDER;
              }), PromptDesigneeType.UNKNOWN, function () {
                return DesigneeProto.DESIGNEE_UNKNOWN;
              }))));
            case 2:
              result = _context.sent;
              _context.next = 5;
              return this.api.getPrompt(result.getId());
            case 5:
              prompt = _context.sent;
              _context.t0 = this.prompts;
              _context.next = 9;
              return this.enrichPromptWithPrivateIds(prompt.toObject());
            case 9:
              _context.t1 = _context.sent;
              _context.t0.set.call(_context.t0, _context.t1);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createPrompt(_x) {
        return _createPrompt.apply(this, arguments);
      }
      return createPrompt;
    }()
    /**
     * Retrieves the Prompt by the given ID.
     */
    )
  }, {
    key: "getPrompt",
    value: (function () {
      var _getPrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(promptId) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.api.getPrompt(promptId).then(function (response) {
                return response.toObject();
              }).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(p) {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", _this2.enrichPromptWithPrivateIds(p));
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()).then(this.prompts.set));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getPrompt(_x2) {
        return _getPrompt.apply(this, arguments);
      }
      return getPrompt;
    }()
    /**
     * Fetches prompts for a job.
     *
     * @param payload
     * @returns {Promise<{[p: string]: *}>}
     */
    )
  }, {
    key: "fetchPromptsForJob",
    value: (function () {
      var _fetchPromptsForJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
        var _this3 = this;
        var page, promptResult;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return retryOnNetworkFailure(function () {
                return _this3.api.listPromptsForJob(payload);
              }).doneRetrying(function (e) {
                return _this3.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
              });
            case 2:
              page = _context4.sent;
              _context4.next = 5;
              return this.enrichPromptsWithPrivateIds(page.data);
            case 5:
              promptResult = _context4.sent;
              return _context4.abrupt("return", _objectSpread(_objectSpread({}, page), {}, {
                data: this.prompts.set(promptResult)
              }));
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchPromptsForJob(_x4) {
        return _fetchPromptsForJob.apply(this, arguments);
      }
      return fetchPromptsForJob;
    }())
  }, {
    key: "answerPrompt",
    value: function () {
      var _answerPrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        var _this4 = this;
        var result, prompt;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.api.answerPrompt(payload).catch(function (e) {
                _this4.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 2:
              result = _context5.sent;
              _context5.next = 5;
              return this.api.getPrompt(result.getId());
            case 5:
              prompt = _context5.sent;
              _context5.t0 = this.prompts;
              _context5.next = 9;
              return this.enrichPromptWithPrivateIds(prompt.toObject());
            case 9:
              _context5.t1 = _context5.sent;
              _context5.t0.set.call(_context5.t0, _context5.t1);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function answerPrompt(_x5) {
        return _answerPrompt.apply(this, arguments);
      }
      return answerPrompt;
    }()
    /**
     * Deletes a prompt
     */
  }, {
    key: "deletePrompt",
    value: (function () {
      var _deletePrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
        var _this5 = this;
        var deleteResponse, prompt;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.api.deletePrompt(payload).catch(function (e) {
                _this5.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 2:
              deleteResponse = _context6.sent;
              _context6.next = 5;
              return this.api.getPrompt(deleteResponse.getId());
            case 5:
              prompt = _context6.sent;
              _context6.t0 = this.prompts;
              _context6.next = 9;
              return this.enrichPromptWithPrivateIds(prompt.toObject());
            case 9:
              _context6.t1 = _context6.sent;
              _context6.t0.set.call(_context6.t0, _context6.t1);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function deletePrompt(_x6) {
        return _deletePrompt.apply(this, arguments);
      }
      return deletePrompt;
    }()
    /**
     * Gets or inits a scroll provider.
     * A scroll provider is used to manage infinite scrolling state
     * for APIs using cursor-based paging.
     */
    )
  }, {
    key: "getScrollProvider",
    value: function getScrollProvider(uid, fetchItems, limit) {
      var existing = this.scrollProviders.get(uid);
      if (existing) {
        return existing;
      }
      var newProvider = new InfiniteScrollProvider({
        memoizeInitial: true,
        limit: limit,
        fetchItems: fetchItems
      });
      this.scrollProviders.set(uid, newProvider);
      return newProvider;
    }

    /**
     * Maps an event from the realtime channel and updates the local representation
     * of the associated prompt.
     *
     * @param event
     * @private
     */
  }, {
    key: "mapPromptRealtimeEvent",
    value: (function () {
      var _mapPromptRealtimeEvent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(event) {
        var _event$getPromptCreat, _event$getPromptCreat2, proto, dto, _event$getPromptAnswe, _event$getPromptAnswe2, _proto, _dto, _event$getPromptDelet, _event$getPromptDelet2, _proto2, _dto2;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = event.getTypeCase();
              _context7.next = _context7.t0 === TypeCase.PROMPT_CREATED ? 3 : _context7.t0 === TypeCase.PROMPT_ANSWERED ? 10 : _context7.t0 === TypeCase.PROMPT_DELETED ? 17 : 24;
              break;
            case 3:
              proto = (_event$getPromptCreat = event.getPromptCreated()) === null || _event$getPromptCreat === void 0 ? void 0 : (_event$getPromptCreat2 = _event$getPromptCreat.getPrompt()) === null || _event$getPromptCreat2 === void 0 ? void 0 : _event$getPromptCreat2.toObject();
              if (proto) {
                _context7.next = 6;
                break;
              }
              return _context7.abrupt("return", null);
            case 6:
              _context7.next = 8;
              return this.enrichPromptWithPrivateIds(proto);
            case 8:
              dto = _context7.sent;
              return _context7.abrupt("return", {
                type: 'PromptCreated',
                prompt: this.prompts.set(dto)
              });
            case 10:
              _proto = (_event$getPromptAnswe = event.getPromptAnswered()) === null || _event$getPromptAnswe === void 0 ? void 0 : (_event$getPromptAnswe2 = _event$getPromptAnswe.getPrompt()) === null || _event$getPromptAnswe2 === void 0 ? void 0 : _event$getPromptAnswe2.toObject();
              if (_proto) {
                _context7.next = 13;
                break;
              }
              return _context7.abrupt("return", null);
            case 13:
              _context7.next = 15;
              return this.enrichPromptWithPrivateIds(_proto);
            case 15:
              _dto = _context7.sent;
              return _context7.abrupt("return", {
                type: 'PromptAnswered',
                prompt: this.prompts.set(_dto)
              });
            case 17:
              _proto2 = (_event$getPromptDelet = event.getPromptDeleted()) === null || _event$getPromptDelet === void 0 ? void 0 : (_event$getPromptDelet2 = _event$getPromptDelet.getPrompt()) === null || _event$getPromptDelet2 === void 0 ? void 0 : _event$getPromptDelet2.toObject();
              if (_proto2) {
                _context7.next = 20;
                break;
              }
              return _context7.abrupt("return", null);
            case 20:
              _context7.next = 22;
              return this.enrichPromptWithPrivateIds(_proto2);
            case 22:
              _dto2 = _context7.sent;
              return _context7.abrupt("return", {
                type: 'PromptDeleted',
                prompt: this.prompts.set(_dto2)
              });
            case 24:
              return _context7.abrupt("return", null);
            case 25:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function mapPromptRealtimeEvent(_x7) {
        return _mapPromptRealtimeEvent.apply(this, arguments);
      }
      return mapPromptRealtimeEvent;
    }()
    /**
     * Retrieves all private ids for a list of prompts.
     *
     * @param prompts
     * @returns
     */
    )
  }, {
    key: "enrichPromptsWithPrivateIds",
    value: (function () {
      var _enrichPromptsWithPrivateIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(prompts) {
        var _this6 = this;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", Promise.all(prompts.map(function (prompt) {
                return _this6.enrichPromptWithPrivateIds(prompt);
              })));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function enrichPromptsWithPrivateIds(_x8) {
        return _enrichPromptsWithPrivateIds.apply(this, arguments);
      }
      return enrichPromptsWithPrivateIds;
    }()
    /**
     * Gets all private ids for a prompt.
     *
     * @param prompt
     * @returns
     */
    )
  }, {
    key: "enrichPromptWithPrivateIds",
    value: (function () {
      var _enrichPromptWithPrivateIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(prompt) {
        var _userIds$prompt$creat, _userIds$prompt$answe, _userIds$prompt$delet;
        var ids, userIds;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              ids = [prompt.createdByPublicId, prompt.answeredByPublicId, prompt.deletedByPublicId];
              _context9.next = 3;
              return this.rootStore.userIdLookup.lookupPrivateIds(ids);
            case 3:
              userIds = _context9.sent;
              return _context9.abrupt("return", _objectSpread(_objectSpread({}, prompt), {}, {
                createdById: (_userIds$prompt$creat = userIds[prompt.createdByPublicId]) !== null && _userIds$prompt$creat !== void 0 ? _userIds$prompt$creat : undefined,
                answeredById: prompt.answeredByPublicId ? (_userIds$prompt$answe = userIds[prompt.answeredByPublicId]) !== null && _userIds$prompt$answe !== void 0 ? _userIds$prompt$answe : undefined : null,
                deletedById: prompt.deletedByPublicId ? (_userIds$prompt$delet = userIds[prompt.deletedByPublicId]) !== null && _userIds$prompt$delet !== void 0 ? _userIds$prompt$delet : undefined : null
              }));
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function enrichPromptWithPrivateIds(_x9) {
        return _enrichPromptWithPrivateIds.apply(this, arguments);
      }
      return enrichPromptWithPrivateIds;
    }())
  }]);
}(Store);
/**
 * Maps an application prompt input type to a Prompt Question Bool Input proto type.
 */
export { PromptStore as default };
function toBoolPrompt(_promptInput) {
  return new PromptQuestionInput().setBoolInput(new PromptQuestionInput.BoolInput());
}

/**
 * Maps an application prompt input type to a Prompt Question Document Upload
 * Input proto type.
 */
function toDocumentsPrompt(promptInput) {
  return new PromptQuestionInput().setDocumentsInput(new PromptQuestionInput.DocumentsInput().setOptionsList(promptInput.options.map(function (o) {
    return new PromptQuestionInput.DocumentsInput.PromptDocumentsOption().setId(o.id).setText(o.title);
  })));
}
function toTextPrompt(_promptInput) {
  return new PromptQuestionInput().setTextInput(new PromptQuestionInput.TextInput());
}
function mapPromptInput(promptInput) {
  switch (promptInput.type) {
    case PromptType.Bool:
      return toBoolPrompt(promptInput);
    case PromptType.DocumentUpload:
      return toDocumentsPrompt(promptInput);
    case PromptType.Text:
      return toTextPrompt(promptInput);
  }
}
//# sourceMappingURL=PromptStore.js.map
